export enum ReportAccessType {
  NoAccess = 0, //0
  Read = 1 << 1, //2
  Write = (1 << 2) | Read, //6
  FullAccess = (1 << 3) | Read | Write, //14
  Owner = (1 << 4) | FullAccess, //30
  Supervisor = (1 << 5) | Owner, //62
}
